const system_logic_cells = [
 {
  logic_cell_guid: '9BCF342C-DA51-45A9-A79B-F8706626D0D7',
  logic_cell_name: '始终成立',
  logic_name_id: 'ln_31_true',
  logic_cell_id: 1,
  device_name: '始终成立',
  device_type: 31,
  device_id: 1,
  logic_type: true,
 },
 {
  logic_cell_guid: '4A6ED5C4-0938-4CB6-BB8C-9A43411A1DD0',
  logic_cell_name: '网络设备就绪',
  logic_name_id: 'ln_33_true',
  logic_cell_id: 2,
  device_name: '网络设备就绪',
  device_type: 33,
  device_id: 2,
  logic_type: true,
 },
]

const system_logic_units = [
 {
  logic_unit_guid: '9D33AF1E-E6E7-4BC3-A5A6-744372E83AAF',
  logic_unit_name: '始终成立',
  logic_unit_id: 1,
  logic_unit_type: 1,
  logic_cell_grp_id: 1,
 },
 {
  logic_unit_guid: '7346C6B8-0209-47B0-9363-4702DA6B7CCC',
  logic_unit_name: '网络设备就绪',
  logic_unit_id: 2,
  logic_unit_type: 1,
  logic_cell_grp_id: 2,
 },
]

const logic_category = [
 {
  name: '系统判定',
  dj_type: 0,
 },
 {
  name: '端口组',
  dj_type: 1,
  logic_types: [
   {
    logic_name: '成功',
    logic_name_id: 'ln_1_true',
    logic_value: true,
   },
   {
    logic_name: '失败',
    logic_name_id: 'ln_1_false',
    logic_value: false,
   }
  ],
 },
 {
  name: '网络设备',
  dj_type: 2,
  logic_types: [
   {
    logic_name: '成功',
    logic_name_id: 'ln_2_true',
    logic_value: true,
   },
   {
    logic_name: '失败',
    logic_name_id: 'ln_2_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '输入端口',
  dj_type: 3,
  logic_types: [
   {
    logic_name: '有效',
    logic_name_id: 'ln_3_true',
    logic_value: true,
   },
   {
    logic_name: '无效',
    logic_name_id: 'ln_3_false',
    logic_value: false,
   },
   {
    logic_name: '等于',
    logic_name_id: 'ln_3_2',
    logic_value: 2,
    param_enable: true,
    },
    {
    logic_name: '大于',
    logic_name_id: 'ln_3_3',
    logic_value: 3,
    param_enable: true,
    },
    {
    logic_name: '大于等于',
    logic_name_id: 'ln_3_4',
    logic_value: 4,
    param_enable: true,
    },
    {
    logic_name: '小于',
    logic_name_id: 'ln_3_5',
    logic_value: 5,
    param_enable: true,
    },
    {
    logic_name: '小于等于',
    logic_name_id: 'ln_3_6',
    logic_value: 6,
    param_enable: true,
    },
    {
    logic_name: '不等于',
    logic_name_id: 'ln_3_7',
    logic_value: 7,
    param_enable: true,
    },
  ],
 },
 {
  name: '输出端口',
  dj_type: 4,
  logic_types: [
   {
    logic_name: '有效',
    logic_name_id: 'ln_4_true',
    logic_value: true,
   },
   {
    logic_name: '无效',
    logic_name_id: 'ln_4_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '门',
  dj_type: 5,
  logic_types: [
   {
    logic_name: '关闭',
    logic_name_id: 'ln_5_true',
    logic_value: true,
   },
   {
    logic_name: '打开',
    logic_name_id: 'ln_5_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '锁',
  dj_type: 6,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_6_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_6_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '灯',
  dj_type: 7,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_7_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_7_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '音效',
  dj_type: 8,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_8_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_8_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '超时音效',
  dj_type: 9,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_9_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_9_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '背景音',
  dj_type: 10,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_10_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_10_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '视频',
  dj_type: 11,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_11_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_11_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '图片',
  dj_type: 12,
  logic_types: [
   {
    logic_name: '打开',
    logic_name_id: 'ln_12_true',
    logic_value: true,
   },
   {
    logic_name: '关闭',
    logic_name_id: 'ln_12_false',
    logic_value: false,
   },
  ],
 },
 {
  name: '网络互动',
  dj_type: 13,
  logic_types: [
   {
    logic_name: '成功',
    logic_name_id: 'ln_13_true',
    logic_value: true,
   },
   {
    logic_name: '失败',
    logic_name_id: 'ln_13_false',
    logic_value: false,
   },
   {
    logic_name: '收到事件',
    logic_name_id: 'ln_13_2',
    logic_value: 2,
    param_enable: true,
   },
  ],
 },
 {
  name: '计数器',
  dj_type: 14,
  logic_types: [
      {
      logic_name: '等于',
      logic_name_id: 'ln_14_2',
      logic_value: 2,
      param_enable: true,
      },
      {
      logic_name: '大于',
      logic_name_id: 'ln_14_3',
      logic_value: 3,
      param_enable: true,
      },
      {
      logic_name: '大于等于',
      logic_name_id: 'ln_14_4',
      logic_value: 4,
      param_enable: true,
      },
      {
      logic_name: '小于',
      logic_name_id: 'ln_14_5',
      logic_value: 5,
      param_enable: true,
      },
      {
      logic_name: '小于等于',
      logic_name_id: 'ln_14_6',
      logic_value: 6,
      param_enable: true,
      },
      {
      logic_name: '不等于',
      logic_name_id: 'ln_14_7',
      logic_value: 7,
      param_enable: true,
      },
      {
      logic_name: '变成',
      logic_name_id: 'ln_14_8',
      logic_value: 8,
      param_enable: true,
      },
    ],
 },
 // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 {
  name: '始终执行',
  dj_type: 31,
  logic_types: [
   {
    logic_name: '',
    logic_value: true,
    logic_name_id: 'ln_31_true',
   },
  ],
 },
 {
  name: '网络设备就绪',
  dj_type: 33,
  logic_types: [
   {
    logic_name: '',
    logic_value: true,
    logic_name_id: 'ln_33_true',
   },
  ],
 },
]

export function getLogicCategory() {
 return logic_category
}

export function getSystemLogicCells() {
 return system_logic_cells
}

export function getSystemLogicUnits() {
 return system_logic_units
}
